module.exports = __webpack_public_path__ + "resources/img/zoom-ui-customizations-09.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/zoom-ui-customizations-09.png
// module id = 1405
// module chunks = 0